import React from 'react'
import { CloseIcon, BackArrowIcon, ForwardArrowIcon, ZoomIcon } from '@sainsburys-tech/bolt-icons'
import PropTypes from 'prop-types'
import ThumbnailComponent from '../Thumbnails/Thumbnails'
import * as Styled from './GalleryModal.styles'

const GalleryModal = ({
  isModalOpen,
  onModalClose,
  mediaArray,
  isCurrentAnImage,
  handleZoom,
  isImageMagnified,
  thumbnailProps,
  hideThumbnails
}) => {
  const {
    isMobile,
    isPortrait,
    structuredMedia,
    trackingIndex,
    isFocused,
    partNumber,
    model,
    gltf,
    productName,
    updateTrackingIndex,
    dataTest,
    addKeyDownListener
  } = thumbnailProps || {}

  const changeToNextMedia = () => {
    if (updateTrackingIndex) {
      updateTrackingIndex(trackingIndex === mediaArray.length - 1 ? 0 : trackingIndex + 1)
    }
  }

  const changeToPreviousMedia = () => {
    if (updateTrackingIndex) {
      updateTrackingIndex(trackingIndex === 0 ? mediaArray.length - 1 : trackingIndex - 1)
    }
  }

  return (
    <Styled.GalleryModal
      show={isModalOpen}
      onClose={() => {
        onModalClose()
      }}
      data-test='gallery-modal'
    >
      <Styled.GalleryModalHeader>
        <span aria-live='polite' aria-atomic='true'>
          {trackingIndex + 1} of {mediaArray.length}
        </span>
        <Styled.GalleryModalHeaderButtonContainer>
          {isCurrentAnImage && (
            <Styled.GalleryModalButton
              iconOnlyText='Zoom out'
              iconOnly
              data-test='gallery-modal-zoom-out-button'
              onClick={() => handleZoom()}
              disabled={!isImageMagnified}
            >
              <ZoomIcon dir='out' />
            </Styled.GalleryModalButton>
          )}
          {isCurrentAnImage && (
            <Styled.GalleryModalButton
              iconOnlyText='Zoom in'
              iconOnly
              data-test='gallery-modal-zoom-in-button'
              onClick={() => handleZoom()}
              disabled={isImageMagnified}
            >
              <ZoomIcon dir='in' />
            </Styled.GalleryModalButton>
          )}
          <Styled.GalleryModalButton
            iconOnlyText='Close'
            iconOnly
            onClick={() => {
              onModalClose()
            }}
            data-test='gallery-modal-close-button'
          >
            <CloseIcon />
          </Styled.GalleryModalButton>
        </Styled.GalleryModalHeaderButtonContainer>
      </Styled.GalleryModalHeader>
      <Styled.GalleryModalContentArea isZoomedIn={isImageMagnified}>
        <Styled.GalleryModalButton
          iconOnlyText='Previous image'
          iconOnly
          onClick={() => changeToPreviousMedia()}
          className='gallery-modal-nav-button'
          data-test='gallery-modal-back-button'
          isZoomedIn={isImageMagnified}
        >
          <BackArrowIcon />
        </Styled.GalleryModalButton>
        {mediaArray[trackingIndex]}
        <Styled.GalleryModalButton
          iconOnlyText='Next image'
          iconOnly
          onClick={() => changeToNextMedia()}
          data-test='gallery-modal-next-button'
          className='gallery-modal-nav-button'
          isZoomedIn={isImageMagnified}
        >
          <ForwardArrowIcon />
        </Styled.GalleryModalButton>
      </Styled.GalleryModalContentArea>
      {!hideThumbnails && thumbnailProps && Object.keys(thumbnailProps).length > 0 && (
        <Styled.ThumbnailWrapper
          data-test='thumbnails'
          className={isPortrait ? 'xs-12--none md-2--none' : ''}
          isPortrait={isPortrait}
        >
          <ThumbnailComponent
            dataTest={dataTest}
            isPortrait={!isMobile && isPortrait}
            style={isPortrait ? 'portrait' : 'landscape'}
            structuredMedia={structuredMedia}
            onSlideChange={newIndex => {
              updateTrackingIndex(newIndex)
            }}
            activeSlide={trackingIndex}
            isFocused={isFocused}
            partNumber={partNumber}
            model={model}
            gltf={gltf}
            productName={productName}
            isInModal
            addKeyDownListener={addKeyDownListener} // set to false as thumbnails already being rendered for mobile view & keydown event is added on component mount
          />
        </Styled.ThumbnailWrapper>
      )}
    </Styled.GalleryModal>
  )
}

GalleryModal.propTypes = {
  isModalOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  mediaArray: PropTypes.arrayOf(PropTypes.element),
  isCurrentAnImage: PropTypes.bool,
  handleZoom: PropTypes.func,
  isImageMagnified: PropTypes.bool,
  thumbnailProps: PropTypes.object,
  hideThumbnails: PropTypes.bool
}

export { GalleryModal }
